import { ButtonPropType } from "./types";
import { ReactComponent as Spinner } from "../../assets/icons/buttonSpinner.svg";

const Button = ({
  onClick,
  label,
  color,
  icon,
  loading,
  disabled,
  full,
  backgroundColor,
  type,
  big,
  long,
  slim,
  rounded,
}: ButtonPropType) => {
  return (
    <a
      href="https://kudihero.com/account/kyc/"
      target="_blank"
      rel="noreferrer"
      className={` flex justify-center items-center  text-sm font-medium py-2 px-5 gap-3  ${
        long ? "w-fit" : "w-full"
      } ${disabled ? "cursor-not-allowed" : ""} ${
        slim ? "h-8 text-xs" : "h-11"
      } ${rounded ? "rounded-full" : "rounded-[3px]"}`}
      style={{
        color,
        backgroundColor,
        border: type === "outlined" ? `1px solid ${color}` : "none",
      }}
      // type="submit"
      // onClick={onClick}
    >
      {/* {loading ? (
        <Spinner className="w-[30px] h-[30px] mr-2 stroke-white" />
      ) : (
        <>{icon && <img src={icon} alt="" className="w-5 h-5 mr-2" />}</>
      )} */}
      <span className="whitespace-nowrap font-medium">{label}</span>
    </a>
  );
};

export default Button;
